import { useEffect, useMemo, useState } from "react";
import { ArrowRight, Calendar, PartyPopper } from "lucide-react";
import Gauge from "./Gauge";
import { formatINR } from "./ReportMapper";
import { openStrategyCall } from "./ReportDashboard";

const COLORS = ["#f26b1d", "#ffb020", "#ff7a2f", "#0ea5a4", "#ffffff"];

export default function SuccessScreen({ report, company, onContinue }) {
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShowConfetti(false), 3000);
    return () => clearTimeout(t);
  }, []);

  const pieces = useMemo(
    () => Array.from({ length: 36 }, (_, i) => ({
      left: Math.random() * 100,
      delay: Math.random() * 0.8,
      color: COLORS[i % COLORS.length]
    })),
    []
  );

  return (
    <div className="success-screen">
      {showConfetti && (
        <div className="confetti" aria-hidden>
          {pieces.map((p, i) => (
            <i key={i} style={{ left: `${p.left}%`, animationDelay: `${p.delay}s`, background: p.color }} />
          ))}
        </div>
      )}

      <div className="card success-card">
        <span className="pill"><PartyPopper size={14} /> Report ready</span>
        <h1>{company.name ? `${company.name.split(" ")[0]}, your` : "Your"} AI report is ready</h1>
        <p className="sub">
          Here's a snapshot for <b>{company.companyName}</b>. Your full report has the opportunities and roadmap.
        </p>

        <Gauge value={report.score} size={150} label="AI maturity score" />

        <div className="success-stats">
          <div className="success-stat">
            <div className="v" style={{ color: "#16a34a" }}>{formatINR(report.roi)}</div>
            <div className="l">Estimated annual value</div>
          </div>
          <div className="success-stat">
            <div className="v" style={{ color: "#d9570d" }}>{report.opportunities.length}</div>
            <div className="l">AI opportunities found</div>
          </div>
        </div>

        <div className="success-actions">
          <button className="btn btn-primary btn-lg" onClick={onContinue}>
            View full report <ArrowRight size={18} />
          </button>
          <button className="btn btn-ghost" onClick={() => openStrategyCall(company, report)}>
            <Calendar size={17} /> Book a free AI strategy call
          </button>
        </div>
      </div>
    </div>
  );
}
